// installs interceptors on the client
import isJWTExpired from 'core/axios/isJwtExpired';
import getJwt from 'core/axios/getJwt';
import addBearer from 'core/axios/addBearer';
import refreshJWT from 'core/axios/authentication';

const addAuthenticationInterceptors = client => {
  if (
    typeof document === 'undefined' ||
    typeof document.cookie === 'undefined'
  ) {
    return client;
  }

  // load up the jwt token with each request
  client.interceptors.request.use(async request => {
    const jwt = getJwt();
    if (jwt && isJWTExpired(jwt)) {
      await refreshJWT();
    }
    addBearer({ request });
    return request;
  });

  return client;
};

export default addAuthenticationInterceptors;
